import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const DataContext = createContext(null);

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [team, setTeam] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [activePopup, setActivePopup] = useState(null);
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchAllData = useCallback(async () => {
    try {
      const [teamRes, treatmentsRes, popupRes, contactRes] = await Promise.all([
        fetch(`${API_URL}/api/public/team`),
        fetch(`${API_URL}/api/public/treatments`),
        fetch(`${API_URL}/api/public/popup`),
        fetch(`${API_URL}/api/public/contact`)
      ]);

      if (teamRes.ok) {
        const teamData = await teamRes.json();
        setTeam(teamData);
      }

      if (treatmentsRes.ok) {
        const treatmentsData = await treatmentsRes.json();
        setTreatments(treatmentsData);
      }

      if (popupRes.ok) {
        const popupData = await popupRes.json();
        setActivePopup(popupData);
      }

      if (contactRes.ok) {
        const contactData = await contactRes.json();
        setContact(contactData);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to fetch data:', error);
      }
    } finally {
      setLoading(false);
    }
  }, [API_URL]);

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  // Refresh data (can be called after admin updates)
  const refreshData = useCallback(() => {
    setLoading(true);
    fetchAllData();
  }, [fetchAllData]);

  return (
    <DataContext.Provider value={{
      team,
      treatments,
      activePopup,
      contact,
      loading,
      refreshData
    }}>
      {children}
    </DataContext.Provider>
  );
};
